import InputSelectWithLabelAndValidation from './InputSelectWithLabelAndValidation'

export default InputSelectWithLabelAndValidation
